import { render, staticRenderFns } from "./UserAvatarMenu.vue?vue&type=template&id=662584c0&scoped=true"
import script from "./UserAvatarMenu.vue?vue&type=script&lang=js"
export * from "./UserAvatarMenu.vue?vue&type=script&lang=js"
import style0 from "./UserAvatarMenu.vue?vue&type=style&index=0&id=662584c0&prod&lang=scss&scoped=true"
import style1 from "./UserAvatarMenu.vue?vue&type=style&index=1&id=662584c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "662584c0",
  null
  
)

export default component.exports